// Footer Mobile Accordion Menu
document.addEventListener('DOMContentLoaded', function () {
    let accordionInitialized = false;

    function initAccordionIfMobile() {
      if (window.innerWidth <= 768 && !accordionInitialized) {
        const footerMenuHeadings = document.querySelectorAll('.footer-heading');
        footerMenuHeadings.forEach(heading => {
          heading.addEventListener('click', () => {
            const menu = heading.nextElementSibling;
            heading.classList.toggle('active');
            menu.classList.toggle('active');
          });
        });
        accordionInitialized = true;
      }
    }

    // Run on page load
    initAccordionIfMobile();

    // Optional: re-check on resize (first time only)
    window.addEventListener('resize', initAccordionIfMobile);
});

// Mobile Icons
document.addEventListener("DOMContentLoaded", function () {
  // Find all <li> elements with class containing 'menu-item-icon['
  document.querySelectorAll('li[class*="menu-item-icon["]').forEach(function (li) {
    const classList = Array.from(li.classList);

    // Extract the class like 'menu-item-icon[/uploads/icon.svg]' or full URL
    const iconClass = classList.find(cls => cls.startsWith('menu-item-icon[') && cls.endsWith(']'));
    if (!iconClass) return;

    // Get the icon path exactly as it is inside the brackets
    const iconPath = iconClass.slice(16, -1).trim(); // remove 'menu-item-icon[' and ']'

    // Create <img> element
    const img = document.createElement('img');
    img.src = iconPath;
    img.alt = '';
    img.className = 'menu-icon';

    // Insert <img> before or after the <span> depending on class
    const link = li.querySelector('a');
    const label = link.querySelector('.wp-block-navigation-item__label');

    if (classList.includes('icon-left')) {
      link.insertBefore(img, label);
    } else if (classList.includes('icon-right')) {
      link.appendChild(img);
    }

    // Optionally remove the utility classes
    li.classList.remove(iconClass, 'icon-left', 'icon-right');
  });
});

// OneTrust Modal
document.addEventListener("DOMContentLoaded", function () {
	const oneTrustPopup = document.querySelector(".onetrust-show-modal > a");

	oneTrustPopup.addEventListener('click', function (event) {
		event.preventDefault();

		if (typeof OneTrust !== 'undefined') {
			OneTrust.ToggleInfoDisplay();
		} else {
			console.warn('OneTrust disabled or not loaded.');
		}
	});
});

document.addEventListener("DOMContentLoaded", function () {
	const chatButton = document.querySelector(".open_chat");
	if (chatButton) {
		chatButton.addEventListener("click", function () {
			openCustomerSupportComponent('cs');
		});
	}
});
